"use strict";
// Based on enum TransactionStatus in BE:
// https://github.com/wix-private/cashier/blob/master/payment-services/public-api-modules/pay-api/src/main/proto/wix/payment/api/pay/v2/resources/transaction.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyerServerTransactionStatus = void 0;
// statuses returned from Buyer-based APIs
var BuyerServerTransactionStatus;
(function (BuyerServerTransactionStatus) {
    BuyerServerTransactionStatus["Undefined"] = "UNDEFINED";
    BuyerServerTransactionStatus["Initialization"] = "INITIALIZATION";
    BuyerServerTransactionStatus["Initialized"] = "INITIALIZED";
    BuyerServerTransactionStatus["InProcess"] = "IN_PROCESS";
    BuyerServerTransactionStatus["Approved"] = "APPROVED";
    BuyerServerTransactionStatus["PendingMerchant"] = "PENDING_MERCHANT";
    BuyerServerTransactionStatus["PendingBuyer"] = "PENDING_BUYER";
    BuyerServerTransactionStatus["BuyerCanceled"] = "BUYER_CANCELED";
    BuyerServerTransactionStatus["Timeout"] = "TIMEOUT";
    BuyerServerTransactionStatus["Refund"] = "REFUND";
    BuyerServerTransactionStatus["PartialRefund"] = "PARTIAL_REFUND";
    BuyerServerTransactionStatus["ChargeBack"] = "CHARGE_BACK";
    BuyerServerTransactionStatus["Declined"] = "DECLINED";
    BuyerServerTransactionStatus["Failed"] = "FAILED";
    BuyerServerTransactionStatus["Offline"] = "OFFLINE";
    BuyerServerTransactionStatus["Dispute"] = "DISPUTE";
})(BuyerServerTransactionStatus = exports.BuyerServerTransactionStatus || (exports.BuyerServerTransactionStatus = {}));
//# sourceMappingURL=BuyerServerTransactionStatus.js.map